module.exports = __webpack_public_path__ + "static/img/map-plane-right.7e6dbec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map-plane-right.png
// module id = W/q6
// module chunks = 1